import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

console.info("Bridgetown is loaded!")

import pace from 'pace-js'
import 'pace-js/themes/blue/pace-theme-barber-shop.css'

window.paceOptions = {
  ajax: true,
  document: true,
  eventLag: true,
  elements: {
    selectors: ['img', 'video', 'iframe']
  }
};
pace.start();
pace.on('done', function() {
  document.querySelector('main').classList.remove('opacity-0');
});

import { littlefoot } from 'littlefoot'
import 'littlefoot/dist/littlefoot.css'
import scrollama from "scrollama";
import { select } from "d3";
import { DataTable } from "simple-datatables";

littlefoot()

function run_scrollarama(scrollySelector, childSelector, images) {

  // using d3 for convenience
  var main = select("main");
  var scrolly = main.select(scrollySelector);
  var figure = scrolly.select("figure");
  var child = scrolly.select(childSelector);
  var step = child.selectAll(".step");

  // initialize the scrollama
  var scroller = scrollama();

  // generic window resize listener event
  function handleResize() {
    // 1. update height of step elements
    var stepH = Math.floor(window.innerHeight * 0.75);
    step.style("height", stepH + "px");

    var figureHeight = window.innerHeight / 2;
    var figureMarginTop = (window.innerHeight - figureHeight) / 2;

    figure
      .style("height", figureHeight + "px")
      .style("top", figureMarginTop + "px");

    // 3. tell scrollama to update new element dimensions
    scroller.resize();
  }

  // scrollama event handlers
  function handleStepEnter(response) {
    // console.log(response);
    // response = { element, direction, index }

    // add color to current step only
    step.classed("is-active", function (d, i) {
      return i === response.index;
    });

    // update graphic based on step
    figure.select("img").attr("src", images[response.index]);
    figure.select("img").classed("opacity-100", true)
  }

  function init() {

    // 1. force a resize on load to ensure proper dimensions are sent to scrollama
    handleResize();

    // 2. setup the scroller passing options
    // 		this will also initialize trigger observations
    // 3. bind scrollama event handlers (this can be chained like below)
    scroller
      .setup({
        step: `${childSelector} .step`,
        offset: 0.33,
        debug: false
      })
      .onStepEnter(handleStepEnter);
  }

  // kick things off
  init();

}

run_scrollarama("#scrolly", "#scrolly-child", ["images/IMG_8458.jpeg", "images/IMG_0330.jpeg", "images/DSC03323.JPG"]);
run_scrollarama("#scrolly2", "#scrolly-child2", ["images/phosphates.png", "images/nitrates.png", "images/cssi.png"]);


// DataTable things
const dataTable = new DataTable(".dataframe");
